import {Component, OnDestroy, OnInit} from '@angular/core';
import {Guid} from 'guid-typescript';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction} from '../../../workflow/store/workflow.actions';
import {select, Store} from '@ngrx/store';
import {
  getWorkflowCurrentState,
  getWorkflowStates,
  isWorkflowCleanedUp
} from '../../../workflow/store/workflow.selector';
import {takeUntil} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {IWorkflowCollectionState} from '../../../workflow/store/workflow.reducer';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {MovePreArrangementToArrangementCommand, SaveSelectedPreArrangementsInLeftSideOfTheTransferboxCommand} from '../../commands/dac6-reporter.command';
import {WorkflowState} from '../../../workflow/models/workflow.model';
import {GetSmartGridFieldSectionInfosAction} from '@shared/store/actions/smart-grid.actions';
import {GetFieldSectionsAction} from '@shared/store/actions/virtual-grid.actions';
import {IQueryState} from '@shared/store/reducers/query.reducer';

@Component({
    standalone: false,
    selector: 'particle-pre-arrangemennt-to-arrangement',
  templateUrl: './pre-arrangemennt-to-arrangement.component.html',
  styleUrls: ['./pre-arrangemennt-to-arrangement.component.scss']
})
export class PreArrangemenntToArrangementComponent implements OnInit, OnDestroy {
  apiEndpointKey: string;
  workflowId: string;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  preArrangeMentId: string;
  selectionKey: string;

  constructor(private store: Store<IWorkflowCollectionState>,
              private router: Router,
              private route: ActivatedRoute,
              protected commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private queryState: Store<IQueryState>) {
    this.workflowId = Guid.create().toString();
    this.apiEndpointKey = 'Dac6Api';
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.preArrangeMentId = params['id'];
      }
    });
    this.selectionKey = 'move-to-arrangement';
    const arrangementId = Guid.create().toString();
    const preCommand = new SaveSelectedPreArrangementsInLeftSideOfTheTransferboxCommand(this.selectionKey, this.preArrangeMentId);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
        const currentBasket = Configuration.getCurrentBasket();
        const workflowTemplateId = 'prearrangement-arrangement-ui-workflow' + currentBasket.basketKey;
        const action = new CreateWorkflowAction(url, this.workflowId, 'Move Pre-Arrangement to Arrangement', workflowTemplateId);
        action.setParameters({
          'FILTER_ID': this.preArrangeMentId,
          'ARRANGEMENT_ID': arrangementId
        });
        this.store.dispatch(action);
        this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
        this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
          if (state === 'Finished') {
            this.queryState.dispatch(new GetSmartGridFieldSectionInfosAction('Arrangement'));
            this.queryState.dispatch(new GetFieldSectionsAction('Arrangement'));
            this.router.navigateByUrl(`dac6-reporter/arrangement/detail/${arrangementId}`);
          }
          if (state === 'Cancelled') {
            this.router.navigateByUrl('dac6-reporter/pre-arrangement');
          }
        });
      }
    });
  }

  onGridCellValueChange($event) {

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
